import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { X } from 'lucide-react';

const EditConfirmModal = ({
  isOpen,
  fieldType = 'origin', // 'origin' or 'destination'
  onConfirm,
  onCancel,
  isDark = false
}) => {
  if (!isOpen) return null;

  const fieldLabel = fieldType === 'origin' ? 'origin address' : 'destination address';

  const overlayClassName = 'fixed inset-0 bg-black/50 flex items-center justify-center z-50';

  const modalClassName = clsx(
    'relative w-full max-w-md mx-4 p-6 rounded-lg shadow-xl',
    {
      'bg-slate-800 text-white': isDark,
      'bg-white text-gray-900': !isDark
    }
  );

  const titleClassName = clsx(
    'text-lg font-semibold mb-3',
    {
      'text-white': isDark,
      'text-gray-900': !isDark
    }
  );

  const textClassName = clsx(
    'text-sm mb-6',
    {
      'text-slate-300': isDark,
      'text-gray-600': !isDark
    }
  );

  const buttonBaseClassName = 'px-4 py-2 rounded-lg font-medium transition-colors';

  const cancelButtonClassName = clsx(
    buttonBaseClassName,
    {
      'bg-slate-700 text-white hover:bg-slate-600': isDark,
      'bg-gray-100 text-gray-700 hover:bg-gray-200': !isDark
    }
  );

  const confirmButtonClassName = clsx(
    buttonBaseClassName,
    'bg-blue-600 text-white hover:bg-blue-700'
  );

  const closeButtonClassName = clsx(
    'absolute top-4 right-4 p-1 rounded hover:bg-gray-100 transition-colors',
    {
      'hover:bg-slate-700': isDark,
      'hover:bg-gray-100': !isDark
    }
  );

  return (
    <div className={overlayClassName} onClick={onCancel}>
      <div className={modalClassName} onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          onClick={onCancel}
          className={closeButtonClassName}
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className={titleClassName}>Edit {fieldLabel}?</h2>
        
        <p className={textClassName}>
          To edit your {fieldLabel}, you&apos;ll be taken back to step one of the booking process. 
          Your other selections will be preserved.
        </p>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className={cancelButtonClassName}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={confirmButtonClassName}
          >
            Continue to edit
          </button>
        </div>
      </div>
    </div>
  );
};

EditConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  fieldType: PropTypes.oneOf(['origin', 'destination']),
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isDark: PropTypes.bool
};

export default EditConfirmModal;